import AxiosInstance from "./AxiosInstance";

// Get All Destinations
export const getAllInquiryDetails = async () => {
  try {
    const { data } = await AxiosInstance.get("/inquiry_details");
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const deleteInquiryDetails = async (user) => {
  try {
    const { data } = await AxiosInstance.delete(`/inquiry_details/${user._id}`);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
